import React from 'react';
import { AppHeader } from '../../components/AppHeader/AppHeader';
import { useShellNav } from '../../access/useShellNav';
import {
  Icon,
  MenuLeaf,
  MenuTitle,
  Sidebar,
} from 'barte-design-system';
import {
  Buildings,
  DeviceMobileSpeaker,
  MagnifyingGlass,
  Percent,
  Receipt,
  Storefront,
  Tray,
  UsersThree,
  Warning,
} from '@phosphor-icons/react';
import './PortalPayfacsLayout.css';

export type PortalPayfacsActiveItem =
  | 'transacoes'
  | 'busca-chat'
  | 'pendencias'
  | 'cadastro-novo-seller'
  | 'plano-taxas'
  | 'terminais'
  | 'solicitar-maquininhas'
  | 'usuarios-permissoes'
  | 'detalhe-lojista'
  | 'detalhe-lojista-so-bolsao';

interface PortalPayfacsLayoutProps {
  activeItem?: PortalPayfacsActiveItem;
  children: React.ReactNode;
}

export function PortalPayfacsLayout({ activeItem, children }: PortalPayfacsLayoutProps) {
  const { sidebarProps, navigate } = useShellNav();

  return (
    <div className="app-layout">
      <AppHeader variant="payfac" pillsLabel="Meu Portal" avatarProps={{ variant: 'icon' }} />

      <div className="app-body">
        <Sidebar {...sidebarProps}>
          <MenuLeaf
            label="Transações"
            icon={<Icon icon={Receipt} size={20} weight="regular" />}
            isActive={activeItem === 'transacoes'}
            onClick={() => navigate('/portal-payfacs/transacoes')}
          />
          <MenuLeaf
            label="Busca de Transações"
            icon={<Icon icon={MagnifyingGlass} size={20} weight="regular" />}
            isActive={activeItem === 'busca-chat'}
            onClick={() => navigate('/portal-payfacs/busca-chat')}
          />
          <MenuLeaf
            label="Pendências"
            icon={<Icon icon={Warning} size={20} weight="regular" />}
            isActive={activeItem === 'pendencias'}
            onClick={() => navigate('/portal-payfacs/pendencias')}
          />
          <MenuTitle title="Lojistas" />
          <MenuLeaf
            label="Lojistas"
            icon={<Icon icon={Buildings} size={20} weight="regular" />}
            isActive={activeItem === 'detalhe-lojista'}
            onClick={() => navigate('/portal-payfacs/detalhe-lojista')}
          />
          <MenuLeaf
            label="Lojista — só bolsão"
            icon={<Icon icon={Buildings} size={20} weight="regular" />}
            isActive={activeItem === 'detalhe-lojista-so-bolsao'}
            onClick={() => navigate('/portal-payfacs/detalhe-lojista-so-bolsao')}
          />
          <MenuLeaf
            label="Cadastrar novo lojista"
            icon={<Icon icon={Storefront} size={20} weight="regular" />}
            isActive={activeItem === 'cadastro-novo-seller'}
            onClick={() => navigate('/portal-payfacs/cadastro-novo-seller')}
          />
          <MenuTitle title="Taxas" />
          <MenuLeaf
            label="Plano de Taxas"
            icon={<Icon icon={Percent} size={20} weight="regular" />}
            isActive={activeItem === 'plano-taxas'}
            onClick={() => navigate('/portal-payfacs/plano-taxas')}
          />
          <MenuTitle title="Gestão de POS" />
          <MenuLeaf
            label="Terminais"
            icon={<Icon icon={DeviceMobileSpeaker} size={20} weight="regular" />}
            isActive={activeItem === 'terminais'}
            onClick={() => navigate('/portal-payfacs/terminals')}
          />
          <MenuLeaf
            label="Solicitar Maquininhas"
            icon={<Icon icon={Tray} size={20} weight="regular" />}
            isActive={activeItem === 'solicitar-maquininhas'}
            onClick={() => navigate('/portal-payfacs/solicitar-maquininhas')}
          />
          <MenuTitle title="Administração" />
          <MenuLeaf
            label="Usuários e permissões"
            icon={<Icon icon={UsersThree} size={20} weight="regular" />}
            isActive={activeItem === 'usuarios-permissoes'}
            onClick={() => navigate('/portal-payfacs/usuarios-permissoes')}
          />
        </Sidebar>

        {children}
      </div>
    </div>
  );
}
